import React from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkle, ArrowRight } from "@phosphor-icons/react";

/**
 * Displayed when a premium-only endpoint returns HTTP 402.
 * Props:
 *  - title: e.g. "AI Fundamental Analysis"
 *  - subtitle: short description
 *  - featureBullets: array of strings (what unlocks)
 */
export default function PremiumLock({ title, subtitle, featureBullets = [] }) {
  return (
    <div
      className="relative border border-mod-soft bg-surface rounded-sm p-6 overflow-hidden"
      data-testid="premium-lock"
    >
      {/* decorative grid */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--text-primary)) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--text-primary)) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />
      <div className="relative flex flex-col md:flex-row items-start gap-5">
        <div className="shrink-0 w-12 h-12 rounded-sm border border-mod-soft bg-mod-soft flex items-center justify-center text-mod">
          <Lock size={20} weight="bold" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.25em] text-mod">
            <Sparkle size={10} weight="fill" /> Premium · Locked
          </div>
          <div className="font-mono text-xl text-primary-fg mt-1">{title}</div>
          {subtitle && (
            <div className="text-sm text-secondary-fg mt-1 max-w-xl">{subtitle}</div>
          )}
          {featureBullets.length > 0 && (
            <ul className="mt-4 space-y-1.5 text-sm text-secondary-fg">
              {featureBullets.map((b, i) => (
                <li key={`${i}-${b.slice(0, 24)}`} className="flex items-start gap-2">
                  <span className="text-pos mt-0.5">✓</span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          )}
          <Link
            to="/pricing"
            data-testid="premium-lock-upgrade"
            className="inline-flex items-center gap-2 mt-5 px-4 py-2 rounded-sm font-mono text-[10px] uppercase tracking-widest transition hover:opacity-90"
            style={{ background: "hsl(var(--text-primary))", color: "hsl(var(--bg))" }}
          >
            Start ₹5 · 5-day trial
            <ArrowRight size={12} weight="bold" />
          </Link>
          <div className="text-[10px] font-mono uppercase tracking-widest text-muted-fg mt-2">
            Then ₹299/month · cancel anytime
          </div>
        </div>
      </div>
    </div>
  );
}
